import React from "react";

const ArrowLeft: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 1024 1024"
    width={200}
    height={200}
    className="icon"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M233.603565 436.039734a102.117034 102.117034 0 0 0-9.088416 135.100835l8.577831 9.701119 411.429529 413.063401a102.117034 102.117034 0 0 0 153.17555-134.488133l-8.475714-9.599002-339.232786-340.560307L788.609643 174.926479a102.117034 102.117034 0 0 0 9.394767-134.794485L789.528696 30.63511a102.117034 102.117034 0 0 0-134.794484-9.29265L645.135211 29.61394 233.603565 436.039734z" />
  </svg>
);

export default ArrowLeft;
